import { ChannelsToMessages, MessageTypesForChannel } from './types';
import { useBroadcast as useBroadcastCore } from '@m43/core';

type UseBroadcastReturns<Channel extends keyof ChannelsToMessages> = {
    postMessage: (message: MessageTypesForChannel<Channel>) => void;
};

export function useBroadcast<ChannelName extends keyof ChannelsToMessages>(
    channelName: ChannelName,
    callback?: (message: MessageTypesForChannel<ChannelName>) => void
): UseBroadcastReturns<ChannelName> {
    return useBroadcastCore<ChannelsToMessages, typeof channelName>(channelName, callback);
}
